import apiClient from './client';

function normalizeQueue(queue = {}) {
  return {
    ...queue,
    members: queue.members || queue.member_agent_ids || [],
  };
}

function extractQueuesPayload(payload = {}) {
  const queueList = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.queues)
      ? payload.queues
      : Array.isArray(payload?.data?.queues)
        ? payload.data.queues
        : [];

  return {
    ...payload,
    queues: queueList.map(normalizeQueue),
  };
}

function extractQueuePayload(payload = {}) {
  const queue = payload?.queue || payload?.data?.queue || payload?.data || payload;
  return {
    ...payload,
    queue: normalizeQueue(queue),
  };
}

function extractQueueLeadsPayload(payload = {}) {
  const leadList = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.leads)
      ? payload.leads
      : Array.isArray(payload?.data?.leads)
        ? payload.data.leads
        : [];

  return {
    ...payload,
    leads: leadList,
  };
}

export async function fetchQueues(params = {}) {
  const response = await apiClient.get('/queues', { params });
  return extractQueuesPayload(response.data);
}

export async function getQueue(id) {
  const response = await apiClient.get(`/queues/${id}`);
  return extractQueuePayload(response.data);
}

export async function createQueue(payload) {
  const response = await apiClient.post('/queues', payload);
  return extractQueuePayload(response.data);
}

export async function updateQueue(id, payload) {
  const response = await apiClient.put(`/queues/${id}`, payload);
  return extractQueuePayload(response.data);
}

export async function deleteQueue(id) {
  const response = await apiClient.delete(`/queues/${id}`);
  return response.data;
}

export async function fetchQueueLeads(id, params = {}) {
  const response = await apiClient.get(`/queues/${id}/leads`, { params });
  return extractQueueLeadsPayload(response.data);
}

export async function claimQueueLead(id, leadId) {
  const response = await apiClient.post(`/queues/${id}/claim`, { lead_id: leadId });
  return response.data;
}

export async function autoClaimQueueLead(id) {
  const response = await apiClient.post(`/queues/${id}/auto-claim`);
  return response.data;
}

export async function dispatchQueue(id) {
  const response = await apiClient.post(`/queues/${id}/dispatch`);
  return response.data;
}
